import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-mhd-list-page',
    templateUrl: './mhd-list-page.component.html',
    styleUrl: './mhd-list-page.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MhdListPageComponent {}
